import { Content } from '@/types/content';
import { getOcelotConfig } from 'lib/configs/ocelot';

export const shouldPageBeHiddenFromIndexing = (pageData: Content): boolean => {
  const isEtikettPage = pageData.type === 'front' && pageData.data.publishedUrl.includes('etikett');
  const isHiddenFromLabrador = pageData.meta.seoDisableIndexing;
  const isHiddenEtikettPage =
    isEtikettPage && (pageData.data.counter || '') < getOcelotConfig('seo.etikett.minimumArticles');

  return isHiddenFromLabrador || isHiddenEtikettPage;
};
